import { ReactNode } from "react";
import "./CareText.css";

interface CareTextProps {
  children: ReactNode;
}

export const CareText = ({ children }: CareTextProps) => {
  return <p className="care-text">{children}</p>;
};
